/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { Card } from "@mui/material";
import "./OrganizationInfoComponent.scss";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState, useRef } from "react";
import {
  CardContent,
  CardHeader,
  MoreVerticalIcon,
  TextOverflow,
} from "@forge/common";
import { useTranslation } from "@scuf/localization";

import defaultLogo from "../../../images/LogoShow.png";
import UploadProfilePic from "../../../utils/upload-profile-pic/UploadProfilePic";
import { getOrganisationLogo } from "../../../store/Tenant/tenant-actions";
import { AppDispatch } from "../../../store";
import TreeTableOrganizationData from "../../../models/apiModels/TreeTableOrganizationData";
import updateErrorList from "../../../utils/methods/updateErrorList";
import ErrorHandlingComponent from "../../SharedComponents/ErrorHandlingComponent";
import Loader from "../../Loader/Loader";
import { setErrorPopupsusingErrorCode } from "../../TenantUser/setErrorPopupsusingErrorCode";
import { serverErrorClose } from "../../SharedComponents/serverErrorClose";
import { IErrorProps } from "../../../models";
import { localeKeyMap } from "../../../localization/keys";

export interface Iprops {
  name: string;
  parentName: string;
  editOrgMenu?: () => void;
  deleteOrgMenu?: () => void;
  profilePic?: string;
  isUploadDisabled?: boolean;
  orgInfo: { tenantId: string; UserInfo: TreeTableOrganizationData };
}

const OrganizationInfoComponent = (props: Iprops) => {
  const [t] = useTranslation();
  const BasicInfoGroup = [
    {
      label: t(localeKeyMap.name),
      fieldData: props.name,
    },
    {
      label: t(localeKeyMap.parentName),
      fieldData: props.parentName,
    },
  ];

  const [orgLogo, setOrgLogo] = useState<string>();

  const dispatch = useDispatch<AppDispatch>();

  const tenantId = props.orgInfo?.tenantId;
  const organizationId = props.orgInfo?.UserInfo?.data?.organizationId;

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };
  // istanbul ignore next
  // on handleToastBarClose
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);

  //////////////Error Handling////////////////////////

  useEffect(() => {
    if (tenantId && organizationId) {
      setIsLoading(true);
      dispatch(getOrganisationLogo({ tenantId, organizationId }))
        .then((response: any) => {
          response.status === 204
            ? setOrgLogo(defaultLogo)
            : setOrgLogo(response.payload as string);
        })
        .catch((error: any) => {
          setOrgLogo(defaultLogo);
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <>
      <Card className="container-org-info p-15 m-b15">
        <React.Fragment key=".0">
          {/* <CardHeader
            className="p-15"
            actions={
              <ActionMenu
                items={
                  [
                    // <ActionMenuItem key="Edit" onClick={props.editOrgMenu}>
                    //   Edit
                    // </ActionMenuItem>,
                    // <ActionMenuItem key="Delete">Delete</ActionMenuItem>,
                  ]
                }
              >
                <MUIButton
                  icon={<MoreVerticalIcon />}
                  label="More"
                  variant="secondary"
                />
              </ActionMenu>
            }
            title="ORGANIZATION INFORMATION"
          /> */}
          <CardContent className="p-15 container-img">
            <UploadProfilePic
              isUploadDisabled={true}
              profilePic={
                !orgLogo ? defaultLogo : `data:image/png;base64,${orgLogo}`
              }
              className="org-info-logo"
            />
            {/* {isLoading && (
              <div
                className="form_logo_wrap form_logo_image"
                style={{ background: "#fff" }}
              ></div>
            )} */}
            <div className="grid-row ">
              <div className="menu-title-1">{t(localeKeyMap.organizationInformation)}</div>
              <div className="container-text">
                {BasicInfoGroup.map((item) => {
                  if (item.label === "") {
                    return <div className="w-50"></div>;
                  }
                  return (
                    <div className="w-40">
                      {/* <label className=" label-p-padding data-viz-subtitle-3"> */}
                      {/* className="body-2 label-val" */}

                      <label className="  data-viz-subtitle-3">
                        {item.label}{" "}
                      </label>
                      <TextOverflow className="m-t5\ body-2">
                        {item.fieldData}
                      </TextOverflow>
                    </div>
                  );
                })}
              </div>
            </div>
          </CardContent>
        </React.Fragment>
      </Card>

      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
      {isLoading && <Loader />}
    </>
  );
};
export default OrganizationInfoComponent;
